import Vue from 'vue';
import EntryMemberFormForJobDetailsHorizonSlideMixin from './vue/entry_member_form_for_job_details_horizon_slide_mixin';
import HorizontalStep from './vue/entry_members/horizontal-step';
import ClientMessageMixin from './vue/client_message_mixin';
import entryPanelMixin from './vue/entry_panel_mixin';
import AutocompleteMixin from './vue/autocomplete_mixin';
import ResumeMixin from './vue/resume_mixin';

document.addEventListener('DOMContentLoaded', () => {
  // <body> / <html> への el 指定を Vue が拒否するため、要素の種類まで見てからマウントする
  const mountTarget = document.querySelector('#body_wrapper');
  if (
    !mountTarget ||
    mountTarget === document.body ||
    mountTarget === document.documentElement
  ) {
    return;
  }

  const path = window.location.pathname;

  const vueParams = {
    el: mountTarget,
    mixins: [],
    data: { searchFormState: null },
  };

  if (path === '/') {
    vueParams.mixins.push(AutocompleteMixin);
  }
  if (path === '/entry_member') {
    vueParams.mixins.push(HorizontalStep);
  } else if (path.search(/\/jobs\/\d+/) !== -1 || path === '/service') {
    vueParams.mixins.push(EntryMemberFormForJobDetailsHorizonSlideMixin);
  }
  if (path === '/clients/messages') {
    vueParams.mixins.push(ClientMessageMixin);
  }

  if ($('#entry-panel').length > 0) {
    vueParams.mixins.push(entryPanelMixin);
  }

  if ($('#resume').length > 0) {
    vueParams.mixins.push(ResumeMixin);
  }

  new Vue(vueParams);
});
